import globalIP from '@/GlobelIP';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FlexboxGrid,
  Form,
  Input,
  Message,
  Modal,
  Pagination,
  Stack,
  Table,
  Tooltip,
  Whisper,
  toaster
} from 'rsuite';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
let catalogueCodeCounter = 1;
const { Column, HeaderCell, Cell } = Table;
const ModalEnquiry = ({ open, onClose, empid, byernm, emcomp, ememail }) => {
  const [productdata, setProductData] = useState([]);
  const [customMap, setCustomMap] = useState([]);
  useEffect(() => {
    if (empid) {
      fetchDataproduct();
    }
  }, []);
  const fetchDataproduct = async () => {
    try {
      const pageSize = 100; // safe Strapi limit
      let page = 1;
      let pageCount = 1;
      const allData: any[] = [];

      do {
        const response = await fetch(
          `${globalIP}/api/buyqrenquiry-dets` +
            `?populate=*` +
            `&filters[enqcd][$eq]=${empid}` +
            `&pagination[page]=${page}` +
            `&pagination[pageSize]=${pageSize}`
        );

        const json = await response.json();

        pageCount = json.meta.pagination.pageCount;

        const processedData = json.data.map(item => ({
          prdcd: item.attributes.prdcd,
          customcode: item.attributes.customcode,
          customimage: item.attributes.Custom_Img?.data?.attributes?.url,
          price: item.attributes.price,
          remark: item.attributes.remark
        }));

        allData.push(...processedData);
        page++;
      } while (page <= pageCount);

      // ✅ Deduplicate by product code
      const uniqueProductMap = new Map<string, any>();
      allData.forEach(item => {
        if (!uniqueProductMap.has(item.prdcd)) {
          uniqueProductMap.set(item.prdcd, item);
        }
      });

      const uniqueProductData = Array.from(uniqueProductMap.values());

      setProductData(uniqueProductData.map(item => item.prdcd));
      setCustomMap(uniqueProductData);
    } catch (error) {
      console.error('Error fetching enquiry products:', error);
    }
  };

  const handleGenerateCata = async () => {
    if (productdata.length === 0) {
      toaster.push(
        <Message showIcon type="warning">
          At least 1 product needed to generate catalogue.
        </Message>,
        { placement: 'topEnd' }
      );
      return;
    }

    try {
      setIsLoading(true);

      const allProducts = await fetchAllProductsForCatalogue();
      setAllProductsForCatalogue(allProducts);

      if (allProducts.length === 0) {
        toaster.push(
          <Message showIcon type="warning">
            No products found for catalogue.
          </Message>,
          { placement: 'topEnd' }
        );
        return;
      }

      setOpen1(true); // open catalogue modal
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  /////// Generate Catalogue ///////
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // console.log("loading");
  // console.log(isLoading);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (productdata) {
      fetchProducts();
    }
  }, [productdata, page, pageSize]);
  const fetchProducts = async () => {
    try {
      setIsLoading(true);

      if (!productdata || productdata.length === 0) {
        setData([]);
        setTotal(0);
        return;
      }

      const cleanIds = productdata.filter(Boolean);

      // 🔥 1️⃣ FIRST try with ProductId
      let productIdsQueryParam = cleanIds
        .map(id => `filters[ProductId][$in][]=${encodeURIComponent(id)}`)
        .join('&');

      let apiUrl =
        `${globalIP}/api/products?populate=*` +
        `&${productIdsQueryParam}` +
        `&pagination[pageSize]=${cleanIds.length}`;

      let response = await fetch(apiUrl);
      let json = await response.json();
      let allMatchedProducts = json?.data || [];

      // 🔥 2️⃣ If empty → fallback to ProductCode
      if (allMatchedProducts.length === 0) {
        productIdsQueryParam = cleanIds
          .map(id => `filters[ProductCode][$in][]=${encodeURIComponent(id)}`)
          .join('&');

        apiUrl =
          `${globalIP}/api/products?populate=*` +
          `&${productIdsQueryParam}` +
          `&pagination[pageSize]=${cleanIds.length}`;

        response = await fetch(apiUrl);
        json = await response.json();
        allMatchedProducts = json?.data || [];
      }

      // ✅ Frontend pagination (UNCHANGED)
      const start = (page - 1) * pageSize;
      const end = start + pageSize;

      setData(allMatchedProducts.slice(start, end));
      setTotal(allMatchedProducts.length);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const [catalogueMeta, setcatalogueMeta] = useState<MetaData>();
  const [allProductsForCatalogue, setAllProductsForCatalogue] = useState([]);

  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${globalIP}/api/catalogues?populate=*`);
    const json = await response.json();
    setcatalogueMeta(json.meta);
  };
const fetchAllProductsForCatalogue = async () => {
  try {
    if (!productdata || productdata.length === 0) return [];

    const cleanIds = productdata.filter(Boolean).map(v => String(v).trim());

    let page = 1;
    const pageSize = 100;
    let pageCount = 1;
    let allData: any[] = [];
    let usingField = "ProductId";

    const buildQuery = (field: string) =>
      cleanIds
        .map(id => `filters[${field}][$in][]=${encodeURIComponent(id)}`)
        .join("&");

    let productQuery = buildQuery("ProductId");

    do {
      const apiUrl =
        `${globalIP}/api/products?populate=*` +
        `&${productQuery}` +
        `&pagination[page]=${page}` +
        `&pagination[pageSize]=${pageSize}`;

      const response = await fetch(apiUrl);
      const json = await response.json();

      if (!json?.data || json.data.length === 0) {
        // 🔥 If first page empty → switch to ProductCode
        if (page === 1 && usingField === "ProductId") {
          usingField = "ProductCode";
          productQuery = buildQuery("ProductCode");
          page = 1;
          allData = [];
          continue;
        } else {
          break;
        }
      }

      allData.push(...json.data);

      pageCount = json?.meta?.pagination?.pageCount || 1;
      page++;

    } while (page <= pageCount);

    const valueSet = new Set(cleanIds);

    const safeData = allData.filter(item => {
      if (usingField === "ProductId") {
        return valueSet.has(String(item.attributes?.ProductId));
      } else {
        return valueSet.has(String(item.attributes?.ProductCode));
      }
    });

    const uniqueMap = new Map<string, any>();
    safeData.forEach(item => {
      const key =
        usingField === "ProductId"
          ? String(item.attributes?.ProductId)
          : String(item.attributes?.ProductCode);

      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, item);
      }
    });

    return Array.from(uniqueMap.values());

  } catch (error) {
    console.error("Error fetching catalogue products:", error);
    return [];
  }
};


  const generateCatalogue = () => {
    const nextCode = catalogueMeta?.pagination?.total + 1;
    return `CATLG-${nextCode.toString().padStart(3, '0')}`;
  };

  const [open1, setOpen1] = useState(false);
  const handleClose1 = () => setOpen1(false);
  const [cata, setCata] = useState({
    catalogueName: '',
    BuyerCompany: emcomp,
    BuyerEmail: ememail,
    CatalogueCode: '',
    BuyerName: byernm,
    Status: 'Active',
    CreateBy: '',
    CatalogueProduct: [
      {
        CatalogProduct: '',
        CatalogCode: ''
      }
    ]
  });
  const handleInputChange = (inputName, event) => {
    let value;
    if (event && event.target) {
      value = event.target.value;
    } else {
      value = event;
    }
    setCata({ ...cata, [inputName]: value });
  };
  const datattt = () => {
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit(event);
    }
  };
  const [loadingCata, setLoadingCata] = useState(false);
  const url2 = `${globalIP}/api/catalogues`;
  const submit = e => {
    e.preventDefault();
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      setLoadingCata(true);
      const nextCatalogueCode = generateCatalogue();
      const formData = new FormData();
      const updatedCatalogue = {
        ...cata,
        CatalogueCode: nextCatalogueCode,
        CatalogueProduct: allProductsForCatalogue.map(item => ({
          CatalogProduct: String(item.id),
          CatalogCode: nextCatalogueCode,
          catcd: String(item.attributes.CategoryName),
          prodtypecd: String(item.attributes.ProductTypeName),
          aliascd: String(item.attributes.ProductId),
          productname: String(item.attributes.ProductTypeName),
          description: String(item.attributes.Description),
          unit: String(item.attributes.SizeUnit),
          len: item.attributes.Length,
          wid: item.attributes.Width,
          thick: item.attributes.Height,
          finish: String(item.attributes.FinishName),
          color: String(item.attributes.ColorName),
          netwgt: item.attributes.NetWeight,
          grswgt: item.attributes.GrossWeight,
          saleprice: item.attributes.SellingPrice,
          currency: String(item.attributes.SellingPriceCurrency),
          remark: String(item.attributes.Product_Remark),
          shape: 'N/A',
          cbm: item.attributes.cbm,
          SizeRange: String(item.attributes.SizeRange)
        }))
      };
      formData.append('data', JSON.stringify(updatedCatalogue));
      fetch(url2, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
        })
        .catch(error => console.error(error));
      catalogueCodeCounter++;
      toaster.push(
        <Message showIcon type="success">
          Saved Successfully
        </Message>,
        { placement: 'topCenter' }
      );
      setLoadingCata(false);
      setOpen1(false);
      onClose();
    }
  };
  /////// Generate Catalogue ///////
  return (
    <>
      <Modal size="full" open={open} onClose={onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            height={420}
            data={data}
            // rowHeight={60}
            rowHeight={null} // ✅ allows row to grow with content
            wordWrap
            rowKey="id"
            bordered
            cellBordered
            loading={isLoading}
          >
            <Column width={100} align="center">
              <HeaderCell>
                <b>Sr. No.</b>
              </HeaderCell>
              <Cell>{(_, rowIndex) => (page - 1) * pageSize + rowIndex + 1}</Cell>
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Category</b>
              </HeaderCell>
              <Cell dataKey={'attributes.CategoryName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Image</b>
              </HeaderCell>
              <Table.Cell>
                {rowData => {
                  // Define a function to show the enlarged image on hover
                  const renderTooltip = imageSrc => (
                    <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                      <img
                        src={imageSrc}
                        alt="Product Image"
                        style={{ width: 400, height: 'auto' }}
                      />
                    </Tooltip>
                  );
                  return (
                    <Whisper
                      trigger="hover"
                      placement="right"
                      speaker={renderTooltip(
                        `${globalIP}${rowData.attributes.CoverImage?.data?.attributes?.url}`
                      )}
                    >
                      <img
                        src={`${globalIP}${rowData.attributes.CoverImage?.data?.attributes?.url}`}
                        alt="Product Image"
                        style={{ width: 50, height: 50, marginTop: '-16px' }}
                      />
                    </Whisper>
                  );
                }}
              </Table.Cell>
            </Column>

            <Column width={160} align="center">
              <HeaderCell>
                <b>Alias Code</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductId'} />
            </Column>

            <Column width={160} align="center">
              <HeaderCell>
                <b>Product Name</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Finish</b>
              </HeaderCell>
              <Cell dataKey={'attributes.FinishName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Color</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ColorName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Custom Image</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  const imageUrl = custom?.customimage ? `${globalIP}${custom.customimage}` : null;

                  if (!imageUrl) return '-';

                  return (
                    <Whisper
                      trigger="hover"
                      placement="right"
                      speaker={
                        <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                          <img
                            src={imageUrl}
                            alt="Custom Image"
                            style={{ width: 400, height: 'auto' }}
                          />
                        </Tooltip>
                      }
                    >
                      <img
                        src={imageUrl}
                        alt="Custom Image"
                        style={{ width: 50, height: 50, marginTop: '-16px' }}
                      />
                    </Whisper>
                  );
                }}
              </Cell>
            </Column>

            <Column width={160} align="center">
              <HeaderCell>
                <b>Custom Code</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  return custom?.customcode || '-';
                }}
              </Cell>
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Price</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  return custom?.price || '-';
                }}
              </Cell>
            </Column>
            <Column width={400} align="left" resizable>
              <HeaderCell>
                <b>Remark</b>
              </HeaderCell>

              <Cell style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );

                  return custom?.remark || '-';
                }}
              </Cell>
            </Column>
          </Table>
          <FlexboxGrid justify="end" style={{ marginTop: 12 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              size="sm"
              total={total}
              limit={pageSize}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={setPageSize}
            />
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleGenerateCata}
            appearance="primary"
            color="cyan"
            style={{ marginTop: '20px', opacity: data.length == 0 ? '0.8' : '1' }}
          >
            Generate Catalogue
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="xs">
        <Modal.Header>
          <b>Please fill catalogue name.</b>
        </Modal.Header>
        <Modal.Body>
          <Form fluid>
            <Form.ControlLabel>
              <Stack>
                <p>Catalogue Name </p>
                <p style={{ color: 'red' }}>*</p>
              </Stack>
            </Form.ControlLabel>
            <Input
              id="catalogueName"
              name="catalogueName"
              value={cata && cata.catalogueName ? cata.catalogueName : ''}
              onChange={value => handleInputChange('catalogueName', value)}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Stack justifyContent="flex-end">
            <Button onClick={datattt} appearance="primary" color="cyan" loading={loadingCata}>
              Finish
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalEnquiry;
